<template>
  <s-sidebar margin-top="var(--topbar-height)" :route="route">
    <template #items>
      <s-sidebar-item v-if="equipe"
        route="/"
        label="Home"
        icon="mdiHome"
      />

      <template v-if="isAdmin">
        <s-sidebar-item-group label="Usuários" icon="mdiAccountMultipleOutline">
          <s-sidebar-sub-item
            route="/usuarios"
            label="Usuários"
          />
          <s-sidebar-sub-item
            route="/usuarios/tipos"
            label="Tipos"
          />
        </s-sidebar-item-group>
      </template>
      
      <template v-else>
        <s-sidebar-item v-if="equipe"
          route="/usuarios"
          label="Usuários"
          icon="mdiAccountMultipleOutline"
        />
      </template>

      <s-sidebar-item v-if="equipe"
        route="/escolas"
        label="Escolas"
        icon="mdiSchool"
      />

      <s-sidebar-item v-if="equipe"
        route="/turmas"
        label="Turmas"
        icon="mdiAccountGroup"
      />

      <s-sidebar-item v-if="equipe || isSuporte"
        route="/equipamentos"
        label="Equipamentos"
        icon="mdiTabletCellphone"
      />

      <s-sidebar-item v-if="equipe"
        route="/relatorios"
        label="Relatórios"
        icon="mdiChartBar"
      />

      <s-sidebar-item v-if="equipe"
        route="/planos"
        label="Planos de Aula"
        icon="mdiBookOpenVariant"
      />

      <s-sidebar-item v-if="!isSuporte"
        route="/agenda"
        label="Agenda"
        icon="mdiCalendarMonthOutline"
      />

      <!-- Conteúdo que vai para os equipamentos e para a equipe. Livros, episódios e coleções
           só para quem mantém o acervo (mesma regra de /acervo em ~/constants/roles). -->
      <s-sidebar-item-group v-if="equipe" label="Acervo" icon="mdiBookshelf">
        <template v-if="isAdmin || isGestor">
          <s-sidebar-sub-item
            route="/acervo"
            label="Livros"
          />
          <s-sidebar-sub-item
            route="/acervo/episodios"
            label="Episódios"
          />
          <s-sidebar-sub-item
            route="/acervo/colecoes"
            label="Coleções"
          />
        </template>
        <s-sidebar-sub-item
          route="/aplicativos"
          label="Aplicativos"
        />
        <s-sidebar-sub-item
          route="/cursos"
          label="Cursos"
        />
        <s-sidebar-sub-item
          route="/guias"
          label="Guias de Uso"
        />
      </s-sidebar-item-group>

      <s-sidebar-item v-if="isAdmin"
        route="/organizacao"
        label="Organização"
        icon="mdiDomain"
      />
    </template>

    <template #actions>
      <div class="version-container" v-tooltip="`Versão: ${version}`">
        {{ version }}
      </div>
    </template>
  </s-sidebar>
</template>

<script setup lang="ts">
import { SSidebar, SSidebarItem, SSidebarItemGroup, SSidebarSubItem } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();
const { isAdministrador: isAdmin, isGestor, isSuporte } = storeToRefs(authStore);
const route = useRoute();

//? `equipe` é o menu de quem opera as escolas. Fora dele: o Aluno (só Agenda) e o Suporte
//? (só Equipamentos) — a mesma fronteira que o guard global aplica em ~/constants/roles.
const equipe = computed(() =>
  authStore.isAdministrador || authStore.isGestor || authStore.isDocente);
const version = ref<string>(useRuntimeConfig().public.APP_VERSION);
</script>

<style scoped>
.version-container {
  padding: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-tertiary);
  width: 100%;
  text-align: center;
}
</style>
